// extracted by mini-css-extract-plugin
export default {"waveform":"Audiogram_waveform__af5zu"};